import { render, staticRenderFns } from "./DeviceTable.vue?vue&type=template&id=24d9ea7d"
import script from "./DeviceTable.vue?vue&type=script&lang=js"
export * from "./DeviceTable.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports